import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ICalendarEvent } from "../types/Types";

/**
 * @author mb
 */
export const CalendarEventAPI = createApi({
    reducerPath: "calendarEventAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "calendarEvent",
            credentials: 'include'
        }),
    tagTypes: ['calendarEventAPI'], // for caching
    endpoints: (builder) => ({
        getCalendarEventByUid: builder.mutation<ICalendarEvent, string>(
            {
                query: (uid) => ({
                    url: '/' + uid,
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),
        getCalendarEventListe: builder.mutation<ICalendarEvent[], {von?: Date, bis?: Date, besitzerUid?: string}>(
            {
                query: (dto) => ({
                    url: '/list',
                    method: 'post',
                    credentials: 'include',
                    body: dto
                })
            }
        ),
        createOrUpdateCalendarEvent: builder.mutation<void, ICalendarEvent>(
            {
                query: (dto) => ({
                    url: '/createOrUpdate',
                    method: 'post',
                    credentials: 'include',
                    body: dto,
                })
            }
        ),
        deleteCalendarEvent: builder.mutation<void, string>(
            {
                query: (uid) => ({
                    url: '/' + uid,
                    method: 'delete',
                    credentials: 'include',
                })
            }
        ),
        
    })
});

export const {

    useGetCalendarEventByUidMutation,
    useGetCalendarEventListeMutation,
    useCreateOrUpdateCalendarEventMutation,
    useDeleteCalendarEventMutation,

} = CalendarEventAPI;
